import { SHIFT_SETTING_PAGES, SHIFT_SETTING_FLAGS } from '@/constant';
import getGroups from '@/service/facility/getGroups';
import getClasses from '@/service/facility/getClasses';
import getServiceId from '@/service/facility/getServiceId';

function shiftsSettingCtrl($scope) {
  $scope.shiftSettingPages = SHIFT_SETTING_PAGES;
  $scope.shiftSettingFlags = SHIFT_SETTING_FLAGS;

  $scope.simpleSettings;
  $scope.dateShiftsSetting = new Date().getTime();

  /**
   * シフトカテゴリのデータを用意
   */
  const setCategories = (categories) => {
    const categoryList = [];
    // TODO: forEach見直し
    categories.forEach((category) => {
      category.data.forEach((data) => {
        categoryList.push({ id: data.id, age: category.type, name: data.name, disabled: false });
      });
    });
    return categoryList;
  };

  /**
   * クラスを学年毎に振り分ける
   */
  const filterClassesByGrade = (classes) => {
    $scope.classesByGrade = [
      {
        ageName: '0歳児',
        classes: classes.filter((classItem) => classItem.age === '0歳児'),
      },
      {
        ageName: '1歳児',
        classes: classes.filter((classItem) => classItem.age === '1歳児'),
      },
      {
        ageName: '2歳児',
        classes: classes.filter((classItem) => classItem.age === '2歳児'),
      },
      {
        ageName: '3歳児',
        classes: classes.filter((classItem) => classItem.age === '3歳児'),
      },
      {
        ageName: '4歳児',
        classes: classes.filter((classItem) => classItem.age === '4歳児'),
      },
      {
        ageName: '5歳児',
        classes: classes.filter((classItem) => classItem.age === '5歳児'),
      },
    ];
  };

  /**
   * クラスを取得
   */
  $scope.getClass = async (serviceId) => {
    const classSearch = { serviceId, is_all: false, notify: '', state: '' };
    const classCategories = await getClasses(classSearch);
    const classes = setCategories(classCategories);
    $scope.classes = classes;
    filterClassesByGrade(classes);
    $scope.$digest();
  };

  /**
   * グループを取得
   */
  $scope.getGroup = async (serviceId) => {
    const groupSearch = { serviceId, is_all: false, notify: '', state: '' };
    const groupCategories = await getGroups(groupSearch);
    $scope.groups = setCategories(groupCategories);
    $scope.$digest();
  };

  const initial = async () => {
    // 自身の設定を取得
    const authUser = await $scope.getMine();
    if (!authUser) throw new Error('getMine Error');
    const serviceId = getServiceId(authUser);
    $scope.getClass(serviceId);
    $scope.getGroup(serviceId);
  };
  initial();
}

angular.module('inspinia').controller('shiftsSettingCtrl', shiftsSettingCtrl);
